module.exports = __webpack_public_path__ + "img/撤销.1cb63887.svg";